var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1735_34990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "evenodd",
    d: "M7.49935 16.6666C7.95959 16.6666 8.33268 17.0397 8.33268 17.5C8.33268 17.9602 7.95959 18.3333 7.49935 18.3333H2.49935C2.03911 18.3333 1.66602 17.9602 1.66602 17.5C1.66602 17.0397 2.03911 16.6666 2.49935 16.6666H7.49935ZM10.8327 11.6667C11.2929 11.6667 11.666 12.0398 11.666 12.5001C11.666 12.9603 11.2929 13.3334 10.8327 13.3334H2.49935C2.03911 13.3334 1.66602 12.9603 1.66602 12.5001C1.66602 12.0398 2.03911 11.6667 2.49935 11.6667H10.8327ZM14.166 6.66667C14.6263 6.66667 14.9993 7.03977 14.9993 7.50001C14.9993 7.96025 14.6263 8.33334 14.166 8.33334H2.49935C2.03911 8.33334 1.66602 7.96025 1.66602 7.50001C1.66602 7.03977 2.03911 6.66667 2.49935 6.66667H14.166ZM17.4993 1.66669C17.9596 1.66669 18.3327 2.03978 18.3327 2.50002C18.3327 2.96026 17.9596 3.33335 17.4993 3.33335H2.49935C2.03911 3.33335 1.66602 2.96026 1.66602 2.50002C1.66602 2.03978 2.03911 1.66669 2.49935 1.66669H17.4993Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1735_34990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.bba13a68.svg";
export { ForwardRef as ReactComponent };